/*!
 * Copyright Optimus Ride 2019
 */

import { LatLon as VehicleGrpcLatLon } from '../../grpc/common_pb';

export interface Coordinates {
    latitude: number;
    longitude: number;
}

export const EmptyCoordinates: Coordinates = {
    latitude: 0,
    longitude: 0,
};

export function toCoordinates(coordinates: VehicleGrpcLatLon | undefined): Coordinates {
    return coordinates ? {
        latitude: coordinates.getLatitude(),
        longitude: coordinates.getLongitude(),
    } : EmptyCoordinates;
}
